@if (isLoading()) {
  <app-loader></app-loader>
} @else {
  @if (!itemIds?.length) {
    <div class="container-flex-center">
      <div class="info-hint mt-100 font-size-unset" i18n="@@items-supply-chain.no-items-warning">
        Supply chains are only available for deliveries with items in them
      </div>
    </div>
  } @else {
    <mat-menu #menu class="dropdown-menu">
      <app-dropdown-menu>
        <app-dropdown-menu-item (pressed)="onClickGroupDeliveriesByProduct($event)">
          <app-checkbox [checked]="this.shouldGroupByProduct()"></app-checkbox>
          <ng-container i18n="@@items-supply-chain.deliveriesbyproduct">
            Deliveries by product
          </ng-container>
        </app-dropdown-menu-item>
      </app-dropdown-menu>
    </mat-menu>
    <div
      #graphContainer
      class="flow-chart-container"
      [style.height]="heightStyle"
      [style.cursor]="isZoomEnabled ? 'move' : 'unset'"
      [ngClass]="containerClass"
    >
      <div class="supply-chain-buttons">
        <app-button type="ghost" size="large" [matMenuTriggerFor]="menu">
          @if (this.shouldGroupByProduct()) {
            <mat-icon icon-left>check</mat-icon>
          }
          <ng-container i18n="@@shared.group">Group</ng-container>
        </app-button>
        @if (fullScreenOptionEnabled) {
          <app-button (pressed)="fullScreen()" [tp]="translations.fullScreenTp" type="outlined">
            <mat-icon>open_in_full</mat-icon>
          </app-button>
        }
      </div>
      @if (displayZoomPromptOverlay) {
        <div
          (click)="onClickZoomPromptOverlay($event)"
          class="zoom-prompt-overlay"
          i18n="@@shared.clickgraphtozoom"
        >
          Click on the graph to zoom.
        </div>
      }
      <svg class="svg-content" [class]="svgContentClass" [id]="svgId">
        <g>
          @if (hasError) {
            <text
              x="50%"
              y="50%"
              dominant-baseline="middle"
              text-anchor="middle"
              fill="black"
              i18n="@@error.failedtoloadsupplychain"
            >
              Could not load the supply chain.
            </text>
          }
        </g>
      </svg>
    </div>

    <app-slide-overlay-wrapper
      [close]="!isSlideOverVisible()"
      (clickClose)="closeSlideOver($event)"
    >
      <div class="full-width">
        <div class="slide-over-content full-width full-height">
          <div class="container-space-between">
            <app-page-title
              [title]="slideOverTitle"
              (back)="closeSlideOver($event)"
            ></app-page-title>
          </div>
          <div class="overlay-wrapper-content">
            @if (selectedItems?.length) {
              <app-items-table
                [items]="selectedItems"
                [shouldOpenInNewTab]="true"
                [isInboundShared]="isInboundShared()"
                [inboundSharedSenderOrgId]="inboundSharedSenderOrgId()"
                [columns]="[
                  'itemId',
                  'product.name',
                  'materials',
                  'initialQuantity',
                  'deliveredQuantity',
                ]"
              ></app-items-table>
            } @else if (selectedProcesses?.length) {
              <app-processes-table
                [shouldOpenInNewTab]="true"
                [processes]="selectedProcesses"
                [allProcessTypes]="allProcessTypes"
                [columns]="[
                  'recordState',
                  'processId',
                  'type.name',
                  'location.name',
                  'firstInputDate',
                  'lastOutputDate',
                ]"
              ></app-processes-table>
            } @else if (selectedCertificates?.length) {
              <app-certificates-table
                [certificates]="selectedCertificates"
                [shouldOpenInNewTab]="true"
                [isInboundShared]="isInboundShared()"
                [inboundSharedSenderOrgId]="inboundSharedSenderOrgId()"
              ></app-certificates-table>
            } @else if (selectedDocuments?.length || missingDocumentTypes?.length) {
              @if (missingDocumentTypes?.length && !isLoadingMissingData()) {
                <p class="dark-gray bold container-flex">
                  <ng-container i18n="@@shared.missingdocuments">Missing documents</ng-container>
                  <app-indicator [value]="missingDocumentTypes.length"></app-indicator>
                </p>
                <app-missing-document-types-table
                  [rowData]="missingDocumentTypes"
                ></app-missing-document-types-table>
              }
              <p *ngIf="missingDocumentTypes?.length" class="dark-gray bold container-flex">
                <ng-container i18n="@@shared.attacheddocuments">Attached documents</ng-container>
                <app-indicator [value]="selectedDocuments.length"></app-indicator>
              </p>
              <app-documents-table
                [documents]="selectedDocuments"
                [shouldOpenInNewTab]="true"
                [isInboundShared]="isInboundShared()"
                [inboundSharedSenderOrgId]="inboundSharedSenderOrgId()"
              ></app-documents-table>
            }
          </div>
        </div>
      </div>
    </app-slide-overlay-wrapper>
  }
}
@if (itemIds?.length) {
  <ng-template #deliveryTemplate let-delivery let-records="deliveriesRulesetsRecords">
    @if (delivery) {
      <app-delivery-card-content
        [shouldOpenInNewTab]="true"
        [delivery]="delivery"
        [showWarning]="!(delivery.id | conditionsMetChecker: records)"
      ></app-delivery-card-content>
    }
  </ng-template>
  <ng-template #groupedProductTemplate let-groupedProduct>
    @if (groupedProduct) {
      <app-grouped-product-card-content
        [groupedProduct]="groupedProduct"
      ></app-grouped-product-card-content>
    }
  </ng-template>
}
